module.exports = __webpack_public_path__ + "img/edit.92150028.svg";